import slugify from "slugify";

export default (name: string) => slugify(name, { lower: true });
